<template>
  <div class="table-container">
    <TableCommon
      title="字典数据"
      :checkbox-config="{ highlight: true }"
      :radio-config="{ highlight: true }"
      :custome-config="() => vxeShowCustom('xTable')"
    >
      <template #button>
        <table-button v-if="mode=== 'add'" name="add" tip="新建" @click="addRow" />
        <table-button v-if="mode=== 'add'" name="add" tip="删除" @click="removeRow" />
      </template>
      <vxe-grid
        ref="xTableEdit"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="300"
        max-height="500"
        align="center"
        size="mini"
        :checkbox-config="{ highlight: true }"
        :radio-config="{ highlight: true }"
        :empty-render="{ name: 'NotData' }"
        :toolbar-config="{ custom: true, size: 'mini' }"
        :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptions.columns"
        :data="gridOptions.data"
      >
        <template #reward_id="{row}">
          <el-input v-model="row.reward_id" placeholder="" size="mini" disabled/>
        </template>
        <template #reward_name="{row}">
          <el-input v-model="row.reward_name" placeholder="请输入项目描述" size="mini" />
        </template>
        <template #reward_short="{row}">
          <el-input v-model="row.reward_short" placeholder="请输入项目类型简称" size="mini" />
        </template>
        
        <!-- pro_control -->
        <template #product_id="{row}">
          <wly-input
            v-model="row.product_id"
            input-type="product"
            @enter="handleEnter(...arguments, row)"
            @handleSuffixClick="openDialog($event, row)"
          />
        </template>
        <template #product_name="{row}">
          <el-input v-model="row.product_name" placeholder="请输入产品名称" size="mini" />
        </template>
        <template #pro_control="{row}">
          <el-select
            v-model="row.pro_control"
            size="mini"
            placeholder=""
            clearable
          >
            <el-option
              v-for="item2 in selectDataOptions['A0078']"
              :key="item2.value"
              :label="item2.name"
              :value="item2.value"
            />
          </el-select>
        </template>
        <template #start_date="{row}">
          <el-date-picker
            v-model="row.start_date"
            type="date"
            value-format="yyyy-MM-dd"
            size="mini"
          />
        </template>
        <template #end_date="{row}">
          <el-date-picker
            v-model="row.end_date"
            type="date"
            value-format="yyyy-MM-dd"
            size="mini"
          />
        </template>
        <template #quota_ratio="{row}">
          <el-input v-model="row.quota_ratio" placeholder="请输入额度比例" size="mini" />
        </template>
        <template #remark="{row}">
          <el-input v-model="row.remark" placeholder="" size="mini" />
        </template>
        <template #status="{row}">
          <el-link
            size="mini"
            :type="row.status == 'V001'? 'success' : 'danger'"
            effect="dark"
          >
            {{ row.status_text }}
          </el-link>
        </template>
      </vxe-grid>

    </TableCommon>
    <el-dialog
      v-dialogDrag
      title="产品选择"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <product-select ref="dialogSelect" />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ProductSelect from '@/components/dialog/ProductSelect'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'

export default {
  components: { ProductSelect },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    editRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showDialog: false,
      rowSeq: 0,
      selectDataOptions: {
        orgList: []
      },
      gridOptions: {
        data: [],
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 40 },
          { field: 'reward_id', title: '项目类型编码', slots: { default: 'reward_id' }},
          { field: 'reward_name', title: '项目类型描述', slots: { default: 'reward_name' }},
          { field: 'reward_short', title: '项目类型简称', slots: { default: 'reward_short' }},
          { field: 'product_id', title: '产品编码', slots: { default: 'product_id' }},
          { field: 'product_name', title: '产品名称', width: 120, slots: { default: 'product_name' }},
          { field: 'pro_control', title: '产品控制', slots: { default: 'pro_control' }},
          { field: 'start_date', title: '有效期起', slots: { default: 'start_date' }},
          { field: 'end_date', title: '有效期止', slots: { default: 'end_date' }},
          { field: 'quota_ratio', title: '额度比例(%)', slots: { default: 'quota_ratio' }},
          { field: 'status', title: '状态', width: 100, slots: { default: 'status' }},
          { field: 'remark', title: '备注', width: 100, slots: { default: 'remark' }},
        ]
      },
      defaultsData: {},
      currentRow: null,
    }
  },
  created() {
    this.defaultsData =  {
      reward_id: '',
      reward_name: '',
      product_id: '',
      product_name: '',
      start_date: '',
      end_date: '',
      quota_ratio: '',
      status: '',
    }
    if (this.editRows.length) {
      this.gridOptions.data.push(...this.editRows.map(item => {
        return { ...item }
      }))
    } else {
      this.gridOptions.data.push({
        ...this.defaultsData
      })
    }
    this.getSelectDictDataOrigin('A0078')
  },
  methods: {
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (data) {
        this.currentRow.product_id = data.PRODUCT_ID
        this.currentRow.product_name = data.SHORT_TEXT
      }
      this.showDialog = false
    },
    openDialog(e, row) {
      this.showDialog = true
      this.currentRow = row
    },
    async handleEnter(e, type, data, row) {
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return
      this.currentRow = row
      this.currentRow.product_id = data.PRODUCT_ID
      this.currentRow.product_name = data.SHORT_TEXT
    },
    addRow() {
      this.gridOptions.data.push({
        ...this.defaultsData
      })
    },
    removeRow() {
      const checkedList = this.$refs['xTableEdit'].getCheckboxRecords()
      if (!checkedList.length) return

      checkedList.forEach(file => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    validRows() {
      try {
        if (!this.gridOptions.data.length) {
          throw new Error('请添加要保存的数据！')
        }
        this.gridOptions.data.forEach(item => {
          if (!item.reward_name || !item.start_date || !item.end_date || !item.quota_ratio) {
            throw new Error('请输入完整的信息！')
          }
        })
      } catch (e) {
        this.$message.error(e.message)
        return false
      }

      return this.gridOptions.data
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/reward-policy/components/DictEdit.vue